var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAssignmentIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 1H12V3H14V14H2V3H4V1H1C0.4 1 0 1.4 0 2V15C0 15.6 0.4 16 1 16H15C15.6 16 16 15.6 16 15V2C16 1.4 15.6 1 15 1Z",
    fill: "#86B4F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 0H5V4H11V0Z",
    fill: "#86B4F9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 6H4V8H12V6Z",
    fill: "#86B4F9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 10H4V12H12V10Z",
    fill: "#86B4F9"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssignmentIcon);
export default __webpack_public_path__ + "static/media/assignment-icon.281c12a6d19b8c6d70b7c6970e5e4720.svg";
export { ForwardRef as ReactComponent };